export enum RegisterActionEnum {
  RegisterForm = 1,
  RegisterOptions = 2,
  TokenReceived = 3,
  RegisterQuestions = 4,
  PasswordDefinition = 5,
  AlertRegisterQuestions = 6,
  ConfirmationData = 7,
}